import {
    appendNotifications,
    fetchNotificationCounts,
    fetchNotifications,
    markAllNotificationsRead,
    markNotificationRead,
    markNotificationsViewed,
    renderEmptyState,
} from "../composants/NotificationList";

/**
 * Cloche de notifications de la barre du haut.
 *
 * Charge sur toutes les pages (global.ts), d'ou un budget reseau serre :
 * au chargement, un seul appel de comptage allume la pastille ; la liste n'est
 * recuperee qu'a l'ouverture du panneau.
 *
 * Deux etats distincts :
 *  - ouvrir le panneau marque les notifications « vues » -> la pastille s'eteint ;
 *  - cliquer une notification la marque « lue » -> son rail se referme.
 */

const PANEL_SIZE = 5;

$(function () {
    const bell = document.getElementById("notificationBell");
    const $badge = $("#notificationBadge");
    const $count = $("#notificationCount");
    const $list = $("#notificationList");
    const $markAll = $("#notificationMarkAll");

    if (bell === null || $list.length === 0) {
        return;
    }

    let loaded = false;

    const setUnreadLabel = (unread: number) => {
        $count.text(unread > 0 ? `${unread} non ${unread > 1 ? "lues" : "lue"}` : "");
        $markAll.prop("disabled", unread === 0);
    };

    const setBadge = (unviewed: number) => {
        $badge.toggleClass("d-none", unviewed === 0).text(unviewed > 99 ? "99+" : String(unviewed));
    };

    const refreshCounts = () => {
        fetchNotificationCounts()
            .done((counts) => {
                setBadge(counts.unviewed);
                setUnreadLabel(counts.unread);
            })
            .fail((error) => console.error(error));
    };

    const loadPanel = () => {
        fetchNotifications({ length: PANEL_SIZE })
            .done((response) => {
                const notifications = response.data ?? [];

                if (notifications.length === 0) {
                    renderEmptyState($list, {
                        title: "Rien à signaler.",
                        hint: "Les alertes de votre flotte apparaîtront ici.",
                    });

                    return;
                }

                $list.empty();
                appendNotifications($list, notifications);
            })
            .fail((error) => {
                console.error(error);
                renderEmptyState($list, {
                    title: "Impossible de charger vos notifications.",
                    hint: "Réessayez dans un instant.",
                    isError: true,
                });
            });
    };

    // Bootstrap 5 emet des evenements natifs : addEventListener, pas jQuery .on().
    bell.addEventListener("show.bs.dropdown", () => {
        if (!loaded) {
            loaded = true;
            loadPanel();
        }

        // L'affichage vaut acquittement : la pastille s'eteint, les rails restent.
        markNotificationsViewed()
            .done(() => setBadge(0))
            .fail((error) => console.error(error));
    });

    $list.on("click", ".nf-item", function () {
        const notificationId = Number($(this).attr("data-notification-id"));

        if (Number.isNaN(notificationId)) {
            return;
        }

        // On ouvre la page dans tous les cas : un acquittement rate ne doit pas
        // retenir l'utilisateur sur place.
        markNotificationRead(notificationId).always(() => {
            window.location.href = "/notifications";
        });
    });

    $markAll.on("click", () => {
        markAllNotificationsRead()
            .done(() => {
                $list.find(".nf-item").addClass("nf-item--read");
                setUnreadLabel(0);
                setBadge(0);
            })
            .fail((error) => console.error(error));
    });

    refreshCounts();
});
